import { Directive, ViewChild, TemplateRef, inject } from '@angular/core';
import { ToolkitApiService } from '../../api';

/**
 * Abstract base class for control bar components in the JMKW application.
 * Provides common functionality and structure for control bar implementations.
 *
 * @abstract
 * @class
 */
@Directive({})
export abstract class AbstractControlBar {
  /**
   * Reference to the control bar's content template.
   * This template can be used to define the structure of the control bar's content
   * in implementing components.
   *
   * @type {TemplateRef<any> | undefined}
   * @memberof AbstractControlBar
   */
  @ViewChild('controlBarContent') controlBarContent?: TemplateRef<any>;

  /**
   * Unique identifier for the control bar instance.
   * Used to identify and manage the control bar within the application.
   *
   * @type {string | undefined}
   * @memberof AbstractControlBar
   */
  id?: string;

  /**
   * Instance of the JMKW API service.
   * Provides access to core JMKW functionality and data management.
   * Injected automatically through Angular's dependency injection.
   *
   * @type {ToolkitApiService}
   * @memberof AbstractControlBar
   */
  toolkitApiService = inject(ToolkitApiService);
}
